import { Controller } from '@hotwired/stimulus';
import Axios from '../axios';

export default class extends Controller {
    static get targets () {
        return ['birthdate', 'parentConsentEl'];
    }

    async selectMembership(event) {
        const element = event.currentTarget;
        const clubId = element.dataset.clubId;
        const membershipId = element.dataset.membershipId;
        const url = `${klark.api_url}/checkout/select-membership`;

        let response;
        element.classList.add('loading');

        const attributeCheckboxPrefix = element.dataset.prefix || 'attr';
        const attributeCheckboxes = document.querySelectorAll(`input[name^="${attributeCheckboxPrefix}_${membershipId}_"]`);
        let additionalMemberships = [];

        if (attributeCheckboxes) {
            attributeCheckboxes.forEach(checkbox => {
                if (checkbox.checked) {
                    let values = checkbox.value.split(',').flat();
                    values.forEach(value => {
                        additionalMemberships.push(parseInt(value));
                    });
                }
            });
        }

        await Axios.post(url, {
            club_id: clubId,
            membership_id: membershipId,
            additional_memberships: additionalMemberships
        })
            .then(res => {
                response = res.data.data;
            })
            .catch(error => {
                response = error.response.data.data;
            });

        if (response && response.redirect) {
            window.location.href = response.redirect;
        }

        element.classList.remove('loading');
    }

    async generateEcontract() {
        const url = `${klark.api_url}/checkout/generate-contract`;
        const contractModal = document.getElementById('e-contract');
        const checkbox = this.element.querySelector('input[name="consents[e_contract]"]');

        if (contractModal && !contractModal.classList.contains('loading') && !checkbox.checked) {
            checkbox.checked = false;
            checkbox.disabled = true;
            checkbox.classList.add('disabled');
            const modalController = Stimulus.getControllerForElementAndIdentifier(contractModal, 'modal');
            modalController.showModal();
            contractModal.classList.add('loading');
            contractModal.querySelector('.modal-footer').style.display = 'none';

            const modalReplaceContent = contractModal.querySelector('.replace-content');
            modalReplaceContent.innerHTML = '';

            let response;
            await Axios.post(url, new FormData(this.element))
                .then(res => {
                    response = res.data.data;
                })
                .catch(error => {
                    response = error.response.data.data;
                });

            if (response && response.contract) {
                modalReplaceContent.innerHTML = '<iframe></iframe>';
                setTimeout(()=>{
                    modalReplaceContent.firstElementChild.contentWindow.document.body.innerHTML = response.contract;
                    modalReplaceContent.firstElementChild.height = modalReplaceContent.firstElementChild.contentWindow.document.body.scrollHeight + 'px';
                }, 100);
                contractModal.querySelector('.modal-footer').style.display = 'block';
            } else if (response && response.errors) {
                modalReplaceContent.innerHTML = '<div class="pb-2 px-2">Patikrinkite visus laukus ir bandykite dar kartą.</span>';
            } else if (response && response.error) {
                modalReplaceContent.innerHTML = `<div class="pb-2 px-2">${response.error}</span>`;
            }

            contractModal.classList.remove('loading');
            const accept = contractModal.querySelector('.modal-accept');
            accept.addEventListener('click', () => {
                checkbox.checked = true;
                checkbox.disabled = false;
                checkbox.classList.remove('disabled');
                modalController.hideModal();
            });

            contractModal.querySelector('.modal-close').addEventListener('click', () => {
                modalController.hideModal();
            });
        }
    }

    updateHiddenField(event) {
        const element = event.currentTarget;
        const hiddenInputSelector = element.dataset.hiddenInput;
        const hiddenInput = document.querySelector(hiddenInputSelector);

        if (hiddenInput) {
            hiddenInput.value = element.value;
        }
    }

    birthdateTargetConnected(element) {
        element.addEventListener('change', () => {

            let maxAgeForParentConsent = element.dataset.checkoutMaxAgeParentConsent;

            if (maxAgeForParentConsent) {
                maxAgeForParentConsent = parseInt(maxAgeForParentConsent);

                const today = new Date(element.dataset.checkoutNow);
                const birthDate = new Date(element.value);
                const age = today.getFullYear() - birthDate.getFullYear();

                const parentConsentEls = document.querySelectorAll('.parent-consent-el');
                const parentConsentElsToHide = document.querySelectorAll('.parent-consent-el-to-hide');
                if (age <= maxAgeForParentConsent) {
                    parentConsentEls.forEach(el => {
                        el.classList.remove('d-none');
                    });
                    parentConsentElsToHide.forEach(el => {
                        el.classList.add('d-none');
                    });
                } else {
                    parentConsentEls.forEach(el => {
                        el.classList.add('d-none');
                    });
                    parentConsentElsToHide.forEach(el => {
                        el.classList.remove('d-none');
                    });
                }
            }
        });
    }

    parentConsentElTargetConnected(element) {
        console.log(element);
    }
}
